<template>
  <div>
    <h1>لیست فیدرها</h1>
    <div class="form-group">
      <input
        class="form-control mt-2 mb-2"
        placeholder="جستجو"
        type="text"
        dir="rtl"
        v-model="inpSearch"
        @keyup="doSearchDelayed"
      />
    </div>

    <div class="row">
      <div class="col-12">
        <div class="list-group">
          <div
            v-bind:key="feeder.feeder_id"
            v-for="feeder in feederArrFiltered"
            class="list-group-item list-group-item-action"
            :class="{ 'list-group-item-warning': feeder.is_use > 0 }"
          >
            {{ feeder.feeder_name }}

            <router-link :to="'/feeder-c/' + feeder.feeder_id">
              map
            </router-link>
            <router-link
              target="_blank"
              :to="'/feeder-pre-cal/' + feeder.feeder_id"
            >
              cal
            </router-link>
            <router-link
              target="_blank"
              :to="'/feeder-print/' + feeder.feeder_id"
            >
              print
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// import {ApiTls} from '../../src/app/tools/ApiTls';
import axios from "axios";
import { UrlTls } from '../app/tools/UrlTls';

export default {
  name: "FeederList",
  data() {
    return {
      feederArr: [],
      inpSearch: "",
      delayTimer: null,
      feederArrFiltered: [],
    };
  },
  created() {
    axios
      .get(UrlTls.getBaseUrl()+"/feeder")
      .then((res) => {
        console.log(res.data);
        this.feederArr = res.data;
        this.feederArrFiltered = res.data;
      })
      .catch((e) => {
        console.log(e);
      });

    // axios.get(UrlTls.getBaseUrl()+'/feeder/', function(res){
    //     console.log(res);
    //     // this.feederArr = res;
    // })
  },
  methods: {
    doSearchDelayed() {
      clearTimeout(this.delayTimer);
      this.delayTimer = setTimeout(this.doSearch, 500);
    },
    doSearch() {
      if (this.inpSearch.length > 2) {
        this.feederArrFiltered = this.feederArr.filter(
          (row) => row.feeder_name.search(this.inpSearch) > -1
        );
      } else {
        this.feederArrFiltered = this.feederArr;
      }
    },
  },
  computed: {
    feederArrFiltered11() {
      if (this.inpSearch.length > 2) {
        return this.feederArr.filter(
          (row) => row.feeder_name.search(this.inpSearch) > -1
        );
      } else {
        return this.feederArr;
      }
    },
  },
};
</script>


<style  scoped>
@font-face {
  font-family: VazirFD;
  src: url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot");
  src: url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot?#iefix")
      format("embedded-opentype"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff2")
      format("woff2"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff")
      format("woff"),
    url("./../../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.ttf")
      format("truetype");

  font-weight: normal;
  font-style: normal;
}

* {
  font-family: "VazirFD", sans-serif;
}
</style>